const isProduction = process.env.REACT_APP_ENV === 'production';

export const WHATSAPP_ROADSHOW_URL = (channel) =>
	isProduction
		? `https://api.whatsapp.com/send?phone=60162285382&text=%5B${channel.toUpperCase()}%5D%20Hello%2C%20I%E2%80%99d%20like%20to%20redeem%20my%2080%20Haleon%20Bonus%20Points.`
		: `https://wa.link/xnbm74`;

export const WHATSAPP_NATIONAL_URL = (channel) =>
	isProduction
		? `https://api.whatsapp.com/send?phone=60162285382&text=%5B${channel.toUpperCase()}%5D%20Hello%2C%20I%E2%80%99d%20like%20to%20redeem%20my%2080%20Haleon%20Bonus%20Points.`
		: `https://api.whatsapp.com/send?phone=60162285382&text=%5B${channel.toUpperCase()}%5D%20Hello%2C%20I%E2%80%99d%20like%20to%20redeem%20my%2080%20Haleon%20Bonus%20Points.`;

export const WHATSAPP_GENERAL_URL = (channel) =>
	isProduction
		? `https://api.whatsapp.com/send?phone=60167015382&text=%5B${channel.toUpperCase()}%5D%20Hi%2C%20I%20would%20like%20to%20join%20Haleon%20Rewards!`
		: `https://api.whatsapp.com/send?phone=60167015382&text=%5B${channel.toUpperCase()}%5D%20Hi%2C%20I%20would%20like%20to%20join%20Haleon%20Rewards!`;

export const WHATSAPP_EVENT_URL = () =>
	isProduction ? `https://wa.link/2lh2jb` : `https://wa.link/2lh2jb`;

export const REWARD_IDS = {
	TNG_RM3: '34902749-87c7-4164-978b-2b7e6e7b4b5f',
	TNG_RM5: 'b5db372b-5b04-4548-88ac-1d0b5d43d475',
	TNG_RM10: '636f410e-4c46-4cd9-8620-31c602ff944c',
	POINTS_20: 'b8e948e3-576d-4e6b-94ad-378578b6eed1',
	POINTS_70: '64c878b6-71bb-462b-abba-72eb787951cb',
	POINTS_100: '4e13e822-e08d-4fbd-a2e4-829e30faa63c',
	POINTS_120: '44bec26d-2d51-4018-8ba8-5db508f7b085',
	POINTS_150: 'fd009504-26b4-4113-ab6e-c01784d6b2a2',
	POINTS_200: '0d18dac3-95f9-41c6-9ae2-cba838ba7aba',
};
